var map = {
	"./da-DK.json": 661,
	"./de-DE.json": 8318,
	"./el-GR.json": 8806,
	"./en-US.json": 5458,
	"./es-ES.json": 9954,
	"./es-MX.json": 1427,
	"./fi-FI.json": 510,
	"./fr-CA.json": 1385,
	"./fr-FR.json": 27,
	"./fr.json": 1822,
	"./hi-IN.json": 7647,
	"./hi.json": 8274,
	"./id-ID.json": 4283,
	"./id.json": 3838,
	"./it-IT.json": 8067,
	"./it.json": 5744,
	"./ja-JP.json": 7815,
	"./ja.json": 5723,
	"./ko-KR.json": 7667,
	"./ko.json": 3355,
	"./nb-NO.json": 4014,
	"./nb.json": 7725,
	"./nl-NL.json": 6494,
	"./nl.json": 5464,
	"./pl-PL.json": 2763,
	"./pl.json": 5726,
	"./pt-BR.json": 788,
	"./pt-PT.json": 680,
	"./qa-PS.json": 9352,
	"./ru-RU.json": 8774,
	"./sv-SE.json": 8509,
	"./sv.json": 840,
	"./th-TH.json": 7403,
	"./tr-TR.json": 5945,
	"./uk-UA.json": 9454,
	"./vi-VN.json": 4406,
	"./zh-CN.json": 7258,
	"./zh-TW.json": 7974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5189;